/**
 * THE PRODUCT'S OWN IDENTITY, AND THE ONE RULE FOR WHICH NAME A SCREEN SHOWS.
 *
 * Two settings named the same idea (owner's settings review, 2026-09-24): the
 * company record's `name` reached only payslips, letters, the 2FA label and
 * phone registration, while Branding's `appName` drove the sign-in page, the
 * sidebar and the browser tab — so an admin who edited Name saw nothing change,
 * and a fresh install called itself "Attendance" and drew an "A" for a logo.
 *
 * Now the COMPANY NAME drives everything. The optional "short display name"
 * that briefly survived as `branding.appName` is gone too (owner, 2026-09-25:
 * "keep company name so it will be display name") — a second name is a second
 * place to be wrong. The public payload keeps the field `appName`, which is
 * the RESOLVED name, never a stored one.
 */

/** The product's name, used only when a company has none yet. */
export const HADIR_NAME = 'Hadir';

/** Hadir's brand colour — the logo tile's ground. The old #6C47FF was a draft. */
export const HADIR_COLOR = '#5323E6';

/** What a screen calls the product: the company name, else Hadir. */
export function brandDisplayName(companyName: string | null | undefined): string {
  return companyName?.trim() || HADIR_NAME;
}
